  import React, { PureComponent } from 'react';
  import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,Label
  } from 'recharts';
/*DIALOG DEPENDENCIES */
import { withStyles } from '@material-ui/core/styles';

/*Events and Styling */

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    margin:"5%"
  }, appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
});

 

 class PerformanceGraph extends PureComponent {

    render() {
      return (
        <div style={{margin:"5%", marginLeft:"15%", marginRight:"15%"}}>
          <div style={{ width: '100%', height: 400}}>
          <ResponsiveContainer>
            <LineChart data={this.props.data}>
              <XAxis dataKey="reporting_number">
                <Label value="Reporting Period" offset={0} position="insideBottom" />
              </XAxis>
              <YAxis />
              <Line type="monotone" dataKey="old_cumulative" stroke="#8884d8" name="Cumulative Planned Value" strokeWidth={4}  dot={{  strokeWidth: 4 }}  activeDot={{stroke:"#8b92a0",strokeWidth: 8 }}/>
              <Line type="monotone" dataKey="cumulative_earned" stroke="#00B050" name="Cumulative Earned Value" strokeWidth={2}  dot={{  strokeWidth: 4 }}  activeDot={{stroke:"#8b92a0",strokeWidth: 8 }}/>
              <Line type="monotone" dataKey="cumulative_actual" stroke="#FF0000" name="Cumulative Actual Cost" strokeWidth={2}  dot={{  strokeWidth: 4 }}  activeDot={{stroke:"#8b92a0",strokeWidth: 8 }}/>
              <CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
              <Tooltip />
            </LineChart>
          </ResponsiveContainer>
          </div>
        </div>
      );
    }
  }



export default withStyles(styles)(PerformanceGraph);


// WEBPACK FOOTER //
// ./src/features/daily/PerformanceGraph.js